import React, { useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useTheme } from "@mui/material/styles";
import { useTemplateController } from "context";
import { I18n } from "aws-amplify/utils";
import ChatBot from "./ChatBot";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

function Chat({ onBotResponse, isMinimized, setIsMinimized, handleLayerSpan, layerSpan, setLayerSpan }) {
  /* -------------------------------------------------------- USESTATE -------------------------------------------*/
  const [open, setOpen] = useState(false); //box chat
  
  const theme = useTheme();
  const [controller] = useTemplateController();
  const { darkMode } = controller;
  const [messages, setMessages] = useState([
    {
      id: 1,
      text: "Hi! How can i help you?",
      sender: "Assistant",
      sent: false,
      time:new Date().toLocaleTimeString([], {hour:"2-digit", minute:"2-digit", hour12:false})
    },

    // { id: 2, text: "Hi! How are you?", sender: "You", sent: true },
  ]);
  /* -------------------------------------------------------- HANDLERS -------------------------------------------*/
  const handleBubbleClick = () => {
    setOpen((prev)=>{
      const newOpen=!prev;
      setIsMinimized(!newOpen);
      return newOpen;
    })
    // if(open){
    //   setOpen(false);
    //   setIsMinimized(true);
    // }else{
    //   setOpen(true);
    //   setIsMinimized(false);
    // } 
  };

  /* -------------------------------------------------------- JSX -------------------------------------------*/
  return (
    <>
      <Box
        sx={{
          position: "fixed",
          bottom: "4%",
          right: "2%",
          zIndex: 1300, // above most content
        }}
      >
        <Tooltip title={I18n.get("Smart Report Assistant")}>
          <IconButton
            onClick={handleBubbleClick}
            sx={{
              height: "60px",
              width: "60px",
              boxShadow: "none",
              color: "#00449e",
              backgroundColor: darkMode ? "#1F2020" : "#transparent",
              "&:hover": {
                color: "#00449e",
                backgroundColor: darkMode ? "#1F2020" : "#e9ecef",
              },
              fontSize: open ? "2.5rem" : "2.5rem",
              borderRadius: "50%",
              borderStyle: "solid",
              borderWidth: "3px",
            }}
          >
            <SupportAgentIcon />
          </IconButton>
        </Tooltip>
      </Box>
      {!isMinimized && open && (
        <ChatBot
          open={open}
          onClose={() => {
            setOpen(false);
            setIsMinimized(true);
            setMessages([
              {
                id: 1,
                text: "Hi! How can i help you?",
                sender: "Assistant",
                sent: false,
                time:new Date().toLocaleTimeString([], {hour:"2-digit", minute:"2-digit", hour12:false})
              },
            ]);
          }}
          onBotResponse={onBotResponse}
          onMinimize={() => {
            setOpen(false)
            setIsMinimized(true); //chat nascosta ma mantenuta
          }}
          messages={messages}
          setMessages={setMessages}
          handleLayerSpan={handleLayerSpan}
          layerSpan={layerSpan}
          setLayerSpan={setLayerSpan}
        />
      )}
    </>
  );
}

export default Chat;
